import { Outlet } from "react-router-dom";
import { WebMcpBridge } from "../../features/webmcp/WebMcpBridge";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";
import { SiteInteractionLayer } from "./SiteInteractionLayer";

export function AppShell() {
  return (
    <div className="site-shell">
      <SiteInteractionLayer />
      <SiteHeader />
      <main className="page-main">
        <Outlet />
      </main>
      <SiteFooter />
      <WebMcpBridge />
    </div>
  );
}
